import { useEffect, useState } from "react";
import { getVoices } from "./service";
import { useOutletContext } from "react-router-dom";
import { message } from "antd";
import { Heading } from "V2.0/common/heading";

import { VoicesTable } from "./VoicesTable";
import { VoicesAdd } from "./VoicesAdd";
import { MicrophoneIcon } from "@heroicons/react/24/outline";
import VoicesDesign from "./VoicesDesignV2";

function VoicesEmptyState() {
  return (
    <div className="w-full h-60 border border-gray-200 rounded-lg">
      <div className="h-full w-full flex justify-center items-center">
        <div className="flex flex-col gap-y-2 items-center">
          <MicrophoneIcon className="size-14 p-2 border rounded-lg text-gray-700" />
          <p className="text-sm text-gray-500">No Voices added</p>
        </div>
      </div>
    </div>
  );
}

function VoicesLibrary() {
  const { projectId, company, isViewOnly } = useOutletContext();
  const [voices, setVoices] = useState({
    data: [],
    isLoading: true,
  });

  const fetchVoices = async () => {
    try {
      const response = await getVoices();
      if (response.status === 200) {
        setVoices({
          data: response.data.voices,
          isLoading: false,
        });
      }
    } catch (error) {
      setVoices((prevState) => {
        return {
          ...prevState,
          isLoading: false,
        };
      });
      message.error("Failed to get Voices");
    }
  };

  useEffect(() => {
    if (projectId) {
      fetchVoices();
    }
  }, [projectId]);

  return (
    <div className="max-w-6xl mx-auto">
      <div className="flex justify-between pt-8">
        <Heading>Voices</Heading>
        <div className="flex items-center gap-x-2">
          {company?.voiceLibrarySettings?.elevenlabsVoicesEnabled && !isViewOnly && (
            <VoicesDesign fetchVoices={fetchVoices} />
          )}
          {company?.voiceLibrarySettings?.elevenlabsVoicesEnabled && !isViewOnly && (
            <VoicesAdd fetchVoices={fetchVoices} />
          )}
        </div>
      </div>
      <div className="mt-8 max-h-[80dvh] overflow-auto">
        {voices.isLoading ? null : voices.data.length > 0 ? (
          <VoicesTable
            voices={voices.data}
            fetchVoices={fetchVoices}
            isViewOnly={isViewOnly}
          />
        ) : (
          <VoicesEmptyState />
        )}
      </div>
    </div>
  );
}

export { VoicesLibrary };
